export const Notifier = class {
  static notify(message, type) {
    switch (type) {
      case "error":
        var icon = getErrorIcon();
        var color = configs.notifications_color;
        break;
      case "info":
        var icon = getSuccessIcon();
        var color = configs.primary_color;
        break;
      case "success":
        var icon = getSuccessIcon();
        var color = configs.primary_color;
        break;
      default:
        var icon = getSuccessIcon();
        var color = configs.primary_color;
    }
    var messageHeader = "";
    var messageBody = "";
    if (typeof message == "string") {
      // Simple Notification
      messageBody = message;
    } else {
      messageHeader = message.header;
      messageBody = message.body;
    }

    var notification = document.createElement("div");
    notification.innerHTML =
      "<div class='gb-notification-container'>" +
      "<div class='icon'>" +
      icon +
      "</div>" +
      "<div class='message-body'>" +
      "<h2 class='header'>" +
      messageHeader +
      "</h2>" +
      "<div class='body'>" +
      messageBody +
      "</div>" +
      "</div>" +
      "<div class='gb-toast-close'>" +
      getNotificationCloseIcon() +
      "</div>" +
      "</div>";

    var myToast = Toastify({
      node: notification.firstChild,
      duration: 7000,
      className: "gb-notification",
      close: false,
      gravity: "top", // `top` or `bottom`
      position: "right",
      onClick: function () {
        $(myToast.toastElement).fadeOut(400, function () {
          myToast.removeElement(myToast.toastElement);
        });
      },
    }).showToast();

    $(myToast.toastElement).animate({
      opacity: "+=1",
    });
  }

  static error(message) {
    this.notify(message, "error");
  }

  static success(message) {
    this.notify(message, "success");
  }

  static info(message) {
    this.notify(message, "info");
  }
};

function getNotificationCloseIcon() {
  return (
    "<svg xmlns='http://www.w3.org/2000/svg' width='17' height='17' viewBox='0 0 17 17'>" +
    "<g id='CLOSE' transform='translate(0 0)'>" +
    "<g id='Path_297' data-name='Path 297' transform='translate(-0.591 15.454) rotate(-45)' fill='#757575' stroke-linecap='round' stroke-linejoin='round'>" +
    "<path d='M 0.5759283900260925 1.76185417175293 L 0.5759317278862 1.259264230728149 L 22.11482238769531 1.259140014648438 L 22.11481857299805 1.761729955673218 L 0.5759283900260925 1.76185417175293 Z' stroke='none'/>" +
    "<path d='M 22.61482429504395 0.7591371536254883 L 22.61481475830078 2.261727094650269 L 0.07592582702636719 2.261857032775879 L 0.07593536376953125 0.7592670917510986 L 22.61482429504395 0.7591371536254883 Z' stroke='none' fill='#757575'/>" +
    "</g>" +
    "<g id='Path_223' data-name='Path 223' transform='translate(1.063 0) rotate(45)' fill='#757575' stroke-linecap='round' stroke-linejoin='round'>" +
    "<path d='M 22.03889656066895 1.002718091011047 L 0.5000068545341492 1.002593874931335 L 0.5000035166740417 0.5000038743019104 L 22.03889274597168 0.5001281499862671 L 22.03889656066895 1.002718091011047 Z' stroke='none'/>" +
    "<path d='M 0 9.5367431640625e-07 L 22.53889083862305 0.0001310110092163086 L 22.53890037536621 1.502721071243286 L 9.5367431640625e-06 1.502591013908386 L 0 9.5367431640625e-07 Z' stroke='none' fill='#757575'/>" +
    "</g>" +
    "</g>" +
    "</svg>"
  );
}

function getSuccessIcon() {
  return (
    "<svg xmlns='http://www.w3.org/2000/svg' width='27' height='27' viewBox='0 0 27 27'>" +
    "<g id='Group_2189' data-name='Group 2189' transform='translate(-97 -511)'>" +
    "<g id='Group_2113' data-name='Group 2113' transform='translate(-842 376)'>" +
    "<circle id='Ellipse_305' data-name='Ellipse 305' cx='13.5' cy='13.5' r='13.5' transform='translate(939 135)' fill='#21a67a'/>" +
    "<path id='Path_358' data-name='Path 358' d='M957.276,144.153l-7.341,8.74-4.589-4.175' transform='translate(1.153 0.141)' fill='none' stroke='#fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'/>" +
    "</g>" +
    "</g>" +
    "</svg>"
  );
}

function getErrorIcon() {
  return (
    "<svg xmlns='http://www.w3.org/2000/svg' width='27' height='27' viewBox='0 0 27 27'>" +
    "<g id='Group_2188' data-name='Group 2188' transform='translate(-97 -254)'>" +
    "<path id='Path_360' data-name='Path 360' d='M13.5,0A13.5,13.5,0,1,1,0,13.5,13.5,13.5,0,0,1,13.5,0Z' transform='translate(97 254)' fill='#f0a92e'/>" +
    "<path id='Path_358' data-name='Path 358' d='M949.936,141.978v7.042' transform='translate(-839.437 119.141)' fill='none' stroke='#fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'/>" +
    "<circle id='Ellipse_310' data-name='Ellipse 310' cx='1.5' cy='1.5' r='1.5' transform='translate(109 272)' fill='#fff'/>" +
    "</g>" +
    "</svg>"
  );
}
